import classnames from 'classnames';
import React, { useEffect } from 'react';
import s from './index.module.scss';

export const Tabs = ({ selected, options = [], onChange }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  useEffect(() => {
    if (selected) {
      const resultIndex = options.findIndex(i => i.value === selected);
      if (resultIndex === -1) return null;
      setSelectedIndex(resultIndex);
    }
  }, [selected]);

  const handleChange = (e, index) => {
    setSelectedIndex(index);
    onChange(e.target.id);
  };

  return (
    <div className={s.container}>
      <div
        className={s.tabs}
        style={{
          gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))`,
        }}
      >
        {options.map((option, index) => (
          <React.Fragment key={option.value}>
            <input
              type="radio"
              id={option.value}
              name="tabs"
              checked={index === selectedIndex}
              onChange={e => handleChange(e, index)}
              className={s.input}
            />
            <label className={s.tab} htmlFor={option.value}>
              <span className={classnames(s.label, 'f-body-accent')}>{option.label}</span>
            </label>
          </React.Fragment>
        ))}
        <span
          className={s.glider}
          style={{
            width: `calc(100% / ${options.length})`,
            transform: `translateX(${selectedIndex * 100}%)`,
          }}
        />
      </div>
    </div>
  );
};
